<template>
   <BreadCrumb PageTitle="Liste des supports de cours" />
    <ListeSupport/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeSupport from "@/components/SupportDeCours/ListeSupport.vue";

    export default defineComponent({
      name: "ListeSupportPage",
      components: {
        BreadCrumb,
        ListeSupport,
      },
    });
  </script>